import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoalibaugcab() {



const cardData =
{
  keyword: 'Mumbai to Alibaug Cab',

  heading: 'Lotus Cab: Mumbai to Alibaug Cab Service',

headingDescription:
    "Lotus Cabs offers reliable and affordable Mumbai to Alibaug Cab services for family vacations, beach holidays, weekend getaways, corporate travel, sightseeing tours, hotel transfers, group outings, and one-way or round-trip journeys. We provide a premium fleet of AC Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus driven by professional and experienced chauffeurs. With 24x7 booking support, transparent pricing, doorstep pickup anywhere in Mumbai, well-maintained vehicles, and safe highway travel, Lotus Cabs ensures a smooth, comfortable, and hassle-free journey to Alibaug. Whether you are planning a relaxing beach vacation, a romantic getaway, or a family holiday along the Konkan coast, our professional drivers and quality vehicles guarantee a pleasant travel experience.",

  top: 'Top Places to Visit in Alibaug with Lotus Cab',

 topPlaces: [
    {
        title: "Alibaug Beach",
        description:
            "Alibaug Beach is the most popular attraction in the coastal town and a favorite destination for travelers seeking a peaceful escape from Mumbai. Famous for its black sand shoreline, refreshing sea breeze, horse cart rides, local seafood stalls, and spectacular sunset views, the beach offers the perfect setting for families, couples, and weekend visitors looking to relax by the Arabian Sea."
    },
    {
        title: "Kolaba Fort",
        description:
            "Kolaba Fort is a magnificent sea fort built by Chhatrapati Shivaji Maharaj in the 17th century and stands as one of Alibaug's most important historical landmarks. Accessible on foot during low tide or by boat during high tide, the fort offers panoramic sea views, ancient temples, historic gateways, and fascinating Maratha architecture, making it a must-visit destination for history lovers."
    },
    {
        title: "Varsoli Beach",
        description:
            "Varsoli Beach is a clean and peaceful beach located just a short distance from Alibaug town. Surrounded by coconut trees and calm waters, it is an ideal destination for morning walks, family picnics, photography, and travelers looking for a quiet coastal experience away from the larger crowds."
    },
    {
        title: "Nagaon Beach",
        description:
            "Nagaon Beach is one of the most popular beaches near Alibaug, well known for its soft sandy shoreline, water sports, beach resorts, and relaxing atmosphere. Visitors can enjoy jet skiing, banana boat rides, parasailing, speed boating, and delicious seafood while spending quality time with family and friends."
    },
    {
        title: "Kihim Beach",
        description:
            "Kihim Beach is famous for its natural beauty, lush greenery, migratory birds, and peaceful surroundings. The beach provides an excellent destination for birdwatching, nature photography, beach walks, and relaxing holidays, making it especially popular among couples, families, and nature enthusiasts."
    },
    {
        title: "Murud-Janjira Fort",
        description:
            "Murud-Janjira Fort is one of India's strongest and most impressive island forts, standing majestically in the Arabian Sea. Known for its remarkable engineering, rich maritime history, massive stone walls, and scenic boat rides, the fort is a major attraction for travelers interested in history, architecture, and coastal heritage."
    },
    {
        title: "Kashid Beach",
        description:
            "Kashid Beach is renowned for its white sand, crystal-clear waters, swaying casuarina trees, and breathtaking coastal scenery. It is one of the finest beaches along the Konkan coastline, offering opportunities for swimming, beach games, water sports, photography, and peaceful vacations with family and friends."
    },
    {
        title: "Revdanda Fort",
        description:
            "Revdanda Fort is a historic Portuguese fort featuring ancient stone walls, church ruins, sea-facing bastions, and centuries-old architecture. Combining history with scenic coastal beauty, the fort attracts visitors interested in exploring Goa-Portuguese heritage and enjoying panoramic views of the Arabian Sea."
    },
    {
        title: "Mandwa Beach",
        description:
            "Mandwa Beach is famous for its luxury beach resorts, ferry connectivity with Mumbai, water sports, and spectacular sea views. Visitors enjoy relaxing by the shoreline, tasting fresh seafood, participating in adventure activities, and witnessing stunning views of the Mumbai skyline across the Arabian Sea."
    },
    {
        title: "Kanakeshwar Temple",
        description:
            "Kanakeshwar Temple is an ancient hilltop temple dedicated to Lord Shiva, surrounded by lush forests and peaceful walking trails. The temple offers a spiritual atmosphere along with breathtaking panoramic views of the Konkan coastline, making it a perfect destination for devotees, trekkers, photographers, and nature lovers visiting Alibaug."
    }
],

  "services": [
    {
      "name": "Mumbai to Alibaug Cab Service",
      "description": "Book Mumbai to Alibaug cab service for smooth and comfortable coastal highway travel covering approximately 95–110 km. Available for one-way drop, round-trip taxi, and full-day beach tour packages. AC sedan, Ertiga, Innova Crysta, SUV, and luxury vehicles ensure relaxed family and group travel. Transparent per kilometer pricing includes tolls and driver allowance details. Professional drivers familiar with NH66 and coastal routes ensure safe and punctual travel."
    },
    {
      "name": "Mumbai to Alibaug One Way Cab",
      "description": "Affordable one-way cab from Mumbai to Alibaug for travelers not returning the same day. Pay only for single-side distance with clear fare breakdown. Ideal for villa stays and extended beach holidays."
    },
    {
      "name": "Mumbai to Alibaug Round Trip Taxi",
      "description": "Round trip taxi option with flexible return timing suitable for weekend trips and corporate outings. Multi-day rental available."
    },
    {
      "name": "Navi Mumbai to Alibaug Taxi Fare",
      "description": "Direct taxi from Navi Mumbai to Alibaug covering shorter distance via Panvel route. Competitive fare structure with AC comfort."
    },
    {
      "name": "Panvel to Alibaug Cab",
      "description": "Convenient Panvel to Alibaug cab service offering quick access to coastal destinations. Ideal for travelers arriving via train or highway."
    },
    {
      "name": "Mumbai to Alibaug Innova Cab",
      "description": "Premium Innova Crysta cab offering spacious seating and enhanced comfort for beach travel."
    },
    {
      "name": "Mumbai to Alibaug Ertiga Cab",
      "description": "Budget-friendly Ertiga cab suitable for small families and economical travel."
    },
    {
      "name": "Mumbai to Alibaug SUV & Luxury Cab",
      "description": "SUV and luxury cab options available for premium coastal travel experience."
    }
  ],

  "tableData": [
    ["Mumbai to Alibaug Cab Service", "Mumbai to Alibaug One Way Cab"],
    ["Mumbai to Alibaug Round Trip Taxi", "Navi Mumbai to Alibaug Taxi Fare"],
    ["Panvel to Alibaug Cab", "Mumbai to Alibaug Innova Cab"],
    ["Mumbai to Alibaug Ertiga Cab", "Mumbai to Alibaug SUV & Luxury Cab"]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "Comfortable Coastal Travel",
      "WhyChoosedescription": "Smooth highway journey via NH66 with experienced drivers."
    },
    {
      "WhyChooseheading": "Transparent Per KM Pricing",
      "WhyChoosedescription": "Clear fare breakdown including toll charges."
    },
    {
      "WhyChooseheading": "One Way & Round Trip Options",
      "WhyChoosedescription": "Flexible booking suitable for short or extended trips."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Categories",
      "WhyChoosedescription": "Sedan, Ertiga, Innova, SUV, and luxury options available."
    },
    {
      "WhyChooseheading": "Panvel & Navi Mumbai Pickup",
      "WhyChoosedescription": "Convenient pickup from multiple Mumbai locations."
    },
    {
      "WhyChooseheading": "Family & Group Friendly",
      "WhyChoosedescription": "Spacious vehicles with luggage capacity."
    },
    {
      "WhyChooseheading": "Professional Drivers",
      "WhyChoosedescription": "Highway-trained chauffeurs ensuring safe travel."
    },
    {
      "WhyChooseheading": "24x7 Booking Support",
      "WhyChoosedescription": "Round-the-clock assistance for booking and fare queries."
    }
  ]
}













const faqData = [
  {
    question: 'Does Lotus Cab provide Mumbai to Alibaug cab service?',
    answer: 'Yes, Lotus Cab offers reliable Mumbai to Alibaug cab service for one-way and round trips with professional drivers and comfortable vehicles.',
  },
  {
    question: 'What is the distance between Mumbai and Alibaug by cab?',
    answer: 'The distance from Mumbai to Alibaug is approximately 95–110 km depending on the route. Travel time usually takes around 2.5 to 3.5 hours.',
  },
  {
    question: 'What are the charges for Mumbai to Alibaug cab booking?',
    answer: 'Cab charges depend on vehicle type, travel date, and whether you choose one-way or round trip. Lotus Cab provides competitive per km pricing with transparent billing.',
  },
  {
    question: 'Can I book a one-way Mumbai to Alibaug cab?',
    answer: 'Yes, Lotus Cab offers affordable one-way Mumbai to Alibaug cab services so customers only pay for the drop without return charges.',
  },
  {
    question: 'Which vehicles are available for Mumbai to Alibaug travel?',
    answer: 'We provide Sedan cars like Dzire and Etios for couples and small families, and SUVs like Ertiga and Innova Crysta for group and beach travel.',
  },
  {
    question: 'Is Mumbai to Alibaug cab service suitable for weekend trips?',
    answer: 'Absolutely. Lotus Cab is ideal for weekend beach getaways to Alibaug with flexible pickup timings and comfortable travel options.',
  },
  {
    question: 'Are toll and parking charges included in the fare?',
    answer: 'Toll, parking, and entry charges are billed separately as per actuals. Lotus Cab ensures complete transparency before confirming your booking.',
  },
  {
    question: 'Can I book a multi-day round trip from Mumbai to Alibaug?',
    answer: 'Yes, Lotus Cab offers flexible multi-day round trip packages perfect for family vacations and group travel to Alibaug.',
  },
  {
    question: 'Is airport pickup available for Mumbai to Alibaug cab?',
    answer: 'Yes, Lotus Cab provides direct pickup from Mumbai Airport for comfortable transfer to Alibaug.',
  },
  {
    question: 'How can I book Mumbai to Alibaug cab with Lotus Cab?',
    answer: 'You can book by sharing your pickup location, travel date, number of passengers, and preferred vehicle to receive instant fare details and booking confirmation.',
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Kunal Shah',
    feedback: 'Booked Lotus Cab for Mumbai to Alibaug weekend trip. Smooth ride, clean car, and very professional driver. Highly recommended.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Ritu Desai',
    feedback: 'Excellent cab service from Mumbai to Alibaug. Transparent pricing and on-time pickup made our beach trip stress-free.',
    rating: 5,
  },
];
















































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];








const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Alibaug Cab",
"image": "https://lotuscab.com/assets/images/mumbai-to-alibaug-cab.jpg",
"description": "Book Mumbai to Alibaug Cab with Lotus Cab for safe, comfortable, and affordable coastal travel. One way and round trip taxi service with Sedan, SUV, and AC cabs available 24x7 with professional drivers and instant booking confirmation.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "9780"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹11/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/mumbai-to-alibaug-cab"
}
};








  return (
    <div>
      
<Helmet>
  <title>Mumbai to Alibaug Cab | One Way & Round Trip Taxi | +91 8767592195</title>

<meta
 name="description"
 content="Book Mumbai to Alibaug Cab with Lotus Cab for affordable coastal travel. One way and round trip taxi service with Sedan, SUV, and AC cabs, professional drivers, instant booking, and 24x7 support for a smooth beach trip."
/>

<meta
 name="keywords"
 content="Mumbai to Alibaug Cab, Mumbai Alibaug Taxi, Alibaug Cab from Mumbai, Mumbai to Alibaug Taxi Service, One Way Cab Mumbai to Alibaug, Round Trip Cab Mumbai to Alibaug, Outstation Cab Mumbai to Alibaug, Beach Cab Mumbai to Alibaug, Affordable Mumbai to Alibaug Cab, Cheap Mumbai to Alibaug Taxi, Online Mumbai Cab Booking, Sedan Cab Mumbai to Alibaug, SUV Cab Mumbai to Alibaug, Best Mumbai Alibaug Cab, Lotus Cab Mumbai"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/88.png' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoalibaugcab;